import React, { useState } from 'react';
import AuditFilterBar from '../components/AuditFilterBar';
import AuditLogTable from '../components/AuditLogTable';
import AuditDetailDrawer from '../components/AuditDetailDrawer';
import { useAuditLogs } from '../hooks/useAuditLogs';
import { PageContainer, PageHeader, SectionContainer } from '../../ui-system';

const AuditLogPage = () => {
  const { filters, setFilters, rows, total, isLoading, error, refetch } = useAuditLogs();
  const [selected, setSelected] = useState(null);

  return (
    <PageContainer>
        <PageHeader
          eyebrow="Audit & Compliance"
          title="Audit Log Center"
          subtitle="Traceability lintas workflow: ticket, dispatch, recovery, billing, dan pipeline."
        />

        <AuditFilterBar filters={filters} onChange={setFilters} onRefresh={refetch} />

        <SectionContainer className="px-3 py-2 text-xs text-slate-400">
          Total log: <span className="font-semibold text-slate-100">{total}</span>
        </SectionContainer>

        {isLoading ? <SectionContainer className="p-4 text-sm text-slate-400">Memuat audit logs...</SectionContainer> : null}
        {error ? <SectionContainer className="p-4 text-sm text-red-200">{error.message || 'Gagal memuat audit logs'}</SectionContainer> : null}

        {!isLoading && !error ? <AuditLogTable rows={rows} onSelect={setSelected} /> : null}
      <AuditDetailDrawer open={Boolean(selected)} log={selected} onClose={() => setSelected(null)} />
    </PageContainer>
  );
};

export default AuditLogPage;
